import React from 'react';
import {
    Tooltip,
    ResponsiveContainer,
    Cell,
    Legend,
    RadialBarChart,
    RadialBar
  } from 'recharts';
import { Card, CardContent } from "../../../components/ui/card";
import constants from '../../../commonUtils/constants';


const VendorCP = ({data}) => {
    return (
        <>
            <Card className="shadow-md rounded-2xl">
                <CardContent>
                    <h2 className="text-lg font-bold mb-4">Vendor vs Channel Partner Uploads</h2>
                    <ResponsiveContainer width="100%" height={250}>
                        <RadialBarChart
                            width={300}
                            height={250}
                            innerRadius="20%"
                            outerRadius="90%"
                            data={data}
                            startAngle={180}
                            endAngle={0}
                        >
                            <RadialBar minAngle={15} label background clockWise dataKey="value">
                                {data.map((entry, index) => (
                                <Cell
                                    key={entry}
                                    fill={index === 0 ? constants.dashboard.colors[0] : constants.dashboard.colors[3]} 
                                />
                                ))}
                            </RadialBar>
                            <Tooltip />
                            <Legend />
                        </RadialBarChart>
                    </ResponsiveContainer>
                </CardContent>
            </Card>
        </>
    );
};

export default VendorCP;
